export default {
      id: "Icon--warning-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--warning",
      toString: function () {
        return this.url;
      }
    }